import { Injectable, inject } from '@angular/core';
import { ServiceInventoryService, ServiceState } from '@brightside-web/desktop/data-access/service-inventory';
import { HomeFeedSection, HomeFeedService } from '@brightside-web/desktop/feature/home-feed';
import { Subject, filter, takeUntil, tap } from 'rxjs';
import { ExternalLendersActionCardComponent } from './home-cards/external-lenders-action-card.component';

@Injectable({ providedIn: 'root' })
export class ExternalLendersCardService {
  private _homeFeedService = inject(HomeFeedService);
  private _serviceInventory = inject(ServiceInventoryService);
  private _unsub$ = new Subject<void>();

  constructor() {
    this._serviceInventory
      .getService('lender_alternatives')
      .pipe(
        filter((service) => !!service),
        tap((service) => {
          switch (service.state) {
            case ServiceState.INITIAL:
              this.registerExternalLendersActionCard(service.route);
              break;
            case ServiceState.MAINTENANCE:
              break;
          }
        }),
        takeUntil(this._unsub$)
      )
      .subscribe();
  }

  ngOnDestroy() {
    this._unsub$.next();
  }

  private registerExternalLendersActionCard(route?: string) {
    this._homeFeedService.registerHomeFeedCard({
      key: 'lender-alternatives',
      component: 'ExternalLendersActionCardComponent',
      componentRef: ExternalLendersActionCardComponent,
      section: HomeFeedSection.ACTIONS,
      data: { route },
      order: 20,
    });
  }
}
